(function () {
  'use strict';

  if (window.__EVOREN_ANALYTICS_CORE__) return;
  window.__EVOREN_ANALYTICS_CORE__ = true;

  function init() {
    var member = window.EvorenAnalyticsMember || {};
    var page = window.EvorenAnalyticsPage || {};

    if (!member.shopifyCustomerId) return;

    var endpoint =
      page.endpoint ||
      'https://evoren-api.evoren-health.workers.dev/analytics';

    var debug = !!page.debug;
    var pageType = page.pageType || 'programme';
    var pageKey = page.pageKey || location.pathname;
    var weekNumber =
      Number.isInteger(page.weekNumber)
        ? page.weekNumber
        : null;

    var SESSION_KEY = 'evoren_analytics_session_v2';
    var SESSION_TIMEOUT = 30 * 60 * 1000;
    var RECENT_ACTIVITY = 2 * 60 * 1000;
    var HEARTBEAT_MS = 60 * 1000;
    var TICK_MS = 15 * 1000;

    function uuid() {
      if (window.crypto && crypto.randomUUID) {
        return crypto.randomUUID();
      }

      return (
        Date.now().toString(36) +
        '-' +
        Math.random().toString(36).slice(2) +
        '-' +
        Math.random().toString(36).slice(2)
      );
    }

    function now() {
      return Date.now();
    }

    function iso(ts) {
      return new Date(ts || now()).toISOString();
    }

    function readSession() {
      try {
        return JSON.parse(
          sessionStorage.getItem(SESSION_KEY) || 'null'
        );
      } catch (e) {
        return null;
      }
    }

    function newSession() {
      var t = now();

      return {
        id: uuid(),
        startedAt: t,
        lastActivityAt: t,
        activeSeconds: 0
      };
    }

    var stored = readSession();

    var resumed = !!(
      stored &&
      stored.id &&
      stored.startedAt &&
      stored.lastActivityAt &&
      now() - stored.lastActivityAt < SESSION_TIMEOUT
    );

    var session = resumed ? stored : newSession();

    function saveSession() {
      try {
        sessionStorage.setItem(
          SESSION_KEY,
          JSON.stringify(session)
        );
      } catch (e) {}
    }

    saveSession();

    function payload(eventType, data) {
      data =
        data && typeof data === 'object'
          ? Object.assign({}, data)
          : {};

      if (
        weekNumber !== null &&
        data.week_number === undefined
      ) {
        data.week_number = weekNumber;
      }

      return {
        event_id: uuid(),
        event_type: eventType,
        event_at: iso(),

        shopify_customer_id:
          String(member.shopifyCustomerId),

        email: member.email || '',
        first_name: member.firstName || '',

        session_id: session.id,

        page_type: pageType,
        page_key: pageKey,
        page_path: location.pathname,

        data: data
      };
    }

    function send(eventType, data, beacon) {
      var body = payload(eventType, data);

      if (debug) {
        console.log(
          '[EVOREN ANALYTICS]',
          body
        );
      }

      if (
        beacon &&
        navigator.sendBeacon
      ) {
        try {
          var blob = new Blob(
            [JSON.stringify(body)],
            {
              type:
                'text/plain;charset=UTF-8'
            }
          );

          if (
            navigator.sendBeacon(
              endpoint,
              blob
            )
          ) {
            return Promise.resolve(true);
          }
        } catch (e) {}
      }

      return fetch(
        endpoint,
        {
          method: 'POST',

          headers: {
            'Content-Type':
              'application/json'
          },

          body: JSON.stringify(body),

          keepalive: true
        }
      )
        .then(function (r) {
          if (!r.ok) {
            throw new Error(
              'HTTP ' + r.status
            );
          }

          return true;
        })
        .catch(function (e) {
          if (debug) {
            console.warn(
              '[EVOREN ANALYTICS] send failed',
              e
            );
          }

          return false;
        });
    }

    function touch() {
      var t = now();

      if (
        t - session.lastActivityAt >=
        SESSION_TIMEOUT
      ) {
        session = newSession();
        saveSession();

        send(
          'session_started',
          {
            started_at:
              iso(session.startedAt),

            reason:
              'inactivity_timeout'
          }
        );

        send(
          'page_viewed',
          {
            title:
              document.title,

            reason:
              'session_restart'
          }
        );
      }

      session.lastActivityAt = t;
      saveSession();
    }

    window.EvorenAnalytics = {
      track: function (
        eventType,
        data
      ) {
        touch();

        return send(
          eventType,
          data || {}
        );
      },

      getSessionId: function () {
        return session.id;
      }
    };

    send(
      resumed
        ? 'session_resumed'
        : 'session_started',

      {
        started_at:
          iso(session.startedAt),

        session_active_seconds:
          Math.round(
            session.activeSeconds || 0
          )
      }
    );

    send(
      'page_viewed',
      {
        title:
          document.title
      }
    );

    var pageActiveSeconds = 0;
    var lastTick = now();
    var pageOpenedAt = now();
    var exiting = false;

    [
      'click',
      'input',
      'change',
      'keydown',
      'touchstart'
    ].forEach(function (name) {
      document.addEventListener(
        name,
        touch,
        { passive: true }
      );
    });

    window.addEventListener(
      'scroll',
      touch,
      { passive: true }
    );

    setInterval(
      function () {
        var t = now();

        var elapsed =
          Math.max(
            0,
            Math.min(
              (t - lastTick) / 1000,
              20
            )
          );

        lastTick = t;

        if (
          document.visibilityState ===
            'visible' &&
          t - session.lastActivityAt <=
            RECENT_ACTIVITY
        ) {
          session.activeSeconds =
            (
              Number(
                session.activeSeconds
              ) || 0
            ) + elapsed;

          pageActiveSeconds +=
            elapsed;

          saveSession();
        }
      },
      TICK_MS
    );

    setInterval(
      function () {
        var t = now();

        if (
          document.visibilityState !==
          'visible'
        ) {
          return;
        }

        if (
          t - session.lastActivityAt >
          RECENT_ACTIVITY
        ) {
          return;
        }

        send(
          'session_heartbeat',
          {
            session_active_seconds:
              Math.round(
                session.activeSeconds || 0
              ),

            page_active_seconds:
              Math.round(
                pageActiveSeconds
              )
          }
        );
      },
      HEARTBEAT_MS
    );

    function slug(s) {
      return String(s || '')
        .trim()
        .toLowerCase()
        .replace(/&/g, ' and ')
        .replace(
          /[^a-z0-9]+/g,
          '_'
        )
        .replace(
          /^_+|_+$/g,
          ''
        );
    }

    var seenSections = {};

    var sectionSets =
      Array.isArray(page.sections)
        ? page.sections
        : page.sections
          ? [page.sections]
          : [];

    sectionSets.forEach(
      function (cfg) {
        if (
          !cfg.selector ||
          !(
            'IntersectionObserver'
            in window
          )
        ) {
          return;
        }

        var threshold =
          Number(cfg.threshold) ||
          0.5;

        var eventType =
          cfg.eventType ||
          'section_opened';

        var headingSelector =
          cfg.headingSelector ||
          'h2';

        var els =
          Array.prototype.slice.call(
            document.querySelectorAll(
              cfg.selector
            )
          );

        els.forEach(
          function (el, i) {
            var heading =
              el.querySelector(
                headingSelector
              );

            var title =
              heading
                ? heading.textContent.trim()
                : '';

            el.__evSectionKey =
              (
                cfg.keys &&
                cfg.keys[i]
              ) ||
              el.getAttribute(
                'data-evoren-analytics-section'
              ) ||
              slug(title) ||
              (
                'section_' +
                (i + 1)
              );
          }
        );

        var observer =
          new IntersectionObserver(
            function (entries) {
              entries.forEach(
                function (entry) {
                  if (
                    !entry.isIntersecting ||
                    entry.intersectionRatio <
                      threshold
                  ) {
                    return;
                  }

                  var key =
                    entry.target
                      .__evSectionKey;

                  var unique =
                    eventType +
                    '|' +
                    key;

                  if (
                    !key ||
                    seenSections[unique]
                  ) {
                    return;
                  }

                  seenSections[unique] =
                    true;

                  var heading =
                    entry.target
                      .querySelector(
                        headingSelector
                      );

                  touch();

                  send(
                    eventType,
                    {
                      section_key:
                        key,

                      section_title:
                        heading
                          ? heading
                              .textContent
                              .trim()
                          : key
                    }
                  );
                }
              );
            },
            {
              threshold:
                [threshold]
            }
          );

        els.forEach(
          function (el) {
            observer.observe(el);
          }
        );
      }
    );

    (page.videos || []).forEach(
      function (
        cfg,
        groupIndex
      ) {
        var videos =
          Array.prototype.slice.call(
            document.querySelectorAll(
              cfg.selector || ''
            )
          );

        videos.forEach(
          function (
            video,
            videoIndex
          ) {
            var contentId =
              cfg.contentId ||
              (
                'video_' +
                (groupIndex + 1) +
                '_' +
                (videoIndex + 1)
              );

            var milestones =
              cfg.milestones ||
              [25, 50, 75, 90];

            var reached = {};
            var started = false;
            var completed = false;
            var lastVideoTouch = 0;

            video.addEventListener(
              'play',
              function () {
                touch();

                if (started) {
                  return;
                }

                started = true;

                send(
                  'video_started',
                  {
                    content_id:
                      contentId,

                    duration_seconds:
                      Number.isFinite(
                        video.duration
                      )
                        ? Math.round(
                            video.duration
                          )
                        : null
                  }
                );
              }
            );

            video.addEventListener(
              'timeupdate',
              function () {
                var t = now();

                if (
                  t -
                    lastVideoTouch >
                  5000
                ) {
                  touch();
                  lastVideoTouch = t;
                }

                if (
                  !Number.isFinite(
                    video.duration
                  ) ||
                  video.duration <= 0
                ) {
                  return;
                }

                var pct =
                  (
                    video.currentTime /
                    video.duration
                  ) * 100;

                milestones.forEach(
                  function (m) {
                    m = Number(m);

                    if (
                      !m ||
                      pct < m ||
                      reached[m]
                    ) {
                      return;
                    }

                    reached[m] =
                      true;

                    send(
                      'video_progress',
                      {
                        content_id:
                          contentId,

                        milestone_percent:
                          m,

                        watched_seconds:
                          Math.round(
                            video.currentTime
                          ),

                        duration_seconds:
                          Math.round(
                            video.duration
                          )
                      }
                    );
                  }
                );
              }
            );

            video.addEventListener(
              'ended',
              function () {
                touch();

                if (completed) {
                  return;
                }

                completed = true;

                send(
                  'video_completed',
                  {
                    content_id:
                      contentId,

                    watched_seconds:
                      Number.isFinite(
                        video.duration
                      )
                        ? Math.round(
                            video.duration
                          )
                        : null,

                    duration_seconds:
                      Number.isFinite(
                        video.duration
                      )
                        ? Math.round(
                            video.duration
                          )
                        : null
                  }
                );
              }
            );
          }
        );
      }
    );

    (page.forms || []).forEach(
      function (cfg) {
        var form =
          document.querySelector(
            cfg.selector || ''
          );

        if (!form) return;

        var started = false;

        function formStarted() {
          touch();

          if (
            started ||
            !cfg.startedEvent
          ) {
            return;
          }

          started = true;

          send(
            cfg.startedEvent,
            {}
          );
        }

        form.addEventListener(
          'input',
          formStarted,
          { passive: true }
        );

        form.addEventListener(
          'change',
          formStarted,
          { passive: true }
        );

        if (
          cfg.submitEvent
        ) {
          form.addEventListener(
            'submit',
            function () {
              touch();

              send(
                cfg.submitEvent,
                {}
              );
            }
          );
        }

        if (
          cfg.completion &&
          cfg.completion.selector &&
          cfg.completion.eventType
        ) {
          var target =
            document.querySelector(
              cfg.completion.selector
            );

          var done = false;

          function checkDone() {
            if (
              !target ||
              done
            ) {
              return;
            }

            var visible =
              !target.hidden &&
              target.offsetParent !==
                null;

            var required =
              String(
                cfg.completion
                  .textIncludes || ''
              ).toLowerCase();

            var text =
              String(
                target.textContent || ''
              ).toLowerCase();

            if (
              visible &&
              (
                !required ||
                text.indexOf(
                  required
                ) !== -1
              )
            ) {
              done = true;

              touch();

              send(
                cfg.completion
                  .eventType,
                {}
              );
            }
          }

          if (target) {
            new MutationObserver(
              checkDone
            ).observe(
              target,
              {
                attributes: true,
                childList: true,
                subtree: true,
                characterData: true
              }
            );

            checkDone();
          }
        }
      }
    );

    var navSelector =
      page.navigationSelector ||
      (
        '.ev-utility-link, ' +
        '.ev-journey-tab[href], ' +
        '.ev-success-button'
      );

    if (navSelector) {
      document.addEventListener(
        'click',
        function (e) {
          var link =
            e.target.closest(
              navSelector
            );

          if (!link) return;

          touch();

          send(
            'programme_navigation',
            {
              destination:
                link.getAttribute(
                  'href'
                ) || '',

              label:
                (
                  link.textContent ||
                  ''
                )
                  .replace(
                    /\s+/g,
                    ' '
                  )
                  .trim()
            }
          );
        }
      );
    }

    window.addEventListener(
      'pagehide',
      function () {
        if (exiting) return;

        exiting = true;

        send(
          'page_exited',
          {
            session_active_seconds:
              Math.round(
                session.activeSeconds || 0
              ),

            page_active_seconds:
              Math.round(
                pageActiveSeconds
              ),

            elapsed_seconds_on_page:
              Math.round(
                (
                  now() -
                  pageOpenedAt
                ) / 1000
              ),

            sections_viewed:
              Object.keys(
                seenSections
              ).length
          },
          true
        );
      }
    );

    if (debug) {
      console.log(
        '[EVOREN ANALYTICS] Shared core loaded',
        {
          customer_id:
            String(
              member.shopifyCustomerId
            ),

          session_id:
            session.id,

          page:
            location.pathname,

          page_key:
            pageKey,

          endpoint:
            endpoint
        }
      );
    }
  }

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      init,
      { once: true }
    );
  } else {
    init();
  }
})();